import { AbstractControl } from '@angular/forms';
import { Range } from '../../interfaces/dataset-filters.interface'
import { validationErrorMessage } from '../../../polly-manage.constants';

export function validateFolderName(control: AbstractControl): { isValidFolderName: boolean } | null {
  return control.value.indexOf('/') >= 0 ? { isValidFolderName: true } : null;
}

export function noWhiteSpacesAllowed(control: AbstractControl): { iswhitespaceAllowed: boolean } | null {
  return !!control.value ? (!(control.value.trim().length === 0) ? null : { iswhitespaceAllowed: true }) : null;
}

export function noHtmlTagsAllowed(control: AbstractControl): { containsHtmlTag: boolean } | null {
  return !!control.value ? /<\/?[^>]+>/.test(control.value) ? { containsHtmlTag: true } : null : null
}

export function rangeNumValidation(range: Range): ({ isRangeValid: boolean, error: string }) {
  const isMinValid = singleRangeNumberValidation(Number(range.min));
  const isMaxValid = singleRangeNumberValidation(Number(range.max));
  let isRangeValid: boolean = false;
  let error: string = '';
  switch (true) {
    case Number(range.min) > Number(range.max):
      error = validationErrorMessage.MIN_GT_MAX;
      break;
    case !isMinValid && !isMaxValid:
      error = validationErrorMessage.INVALID_MIN_MAX;
      break;
    case !isMinValid:
      error = validationErrorMessage.INVALID_MIN;
      break;
    case !isMaxValid:
      error = validationErrorMessage.INVALID_MAX;
      break;
    default:
      isRangeValid = true;
  }

  return { isRangeValid, error };
}

export function singleRangeNumberValidation(inputValue: number): boolean {
  inputValue = Number(inputValue);
  return !isNaN(inputValue) ? (Number.isInteger(inputValue) && inputValue >= 0) : false;
}
